import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black } from 'constants/colors';

export const LoadingWrapper = styled.div`
width: clamp(20vw, 40rem, 100vw);
height: clamp(20vw, 40rem, 100vw);
margin: 0 auto;
border-radius: 50%;
overflow: hidden;
`;

export const FeedbackWrapper = styled.div`
  max-width: 80rem;
  margin: 0 auto;
  padding: 2rem;

  .title {
    font-size: 1.6rem;
    color: ${black};
    line-height: 2.3rem;
    font-family: ${RalewayFont.semiboldFamily};
    margin-bottom: 1rem;
  }

  .carousel {
    height: auto;
  }
`;

export const NoElements = styled.div`
  width: calc(100% - 4rem);
  height: 30rem;
  padding: 2rem;
  margin: 2rem auto;
  background: #F3F3F3;
  border-radius: 3rem;
  display: flex;
  align-items: center;

  .nocontent {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      width: 20rem;
    }

    .text {
      margin-top: 1rem;
      font-size: 1.6rem;
      text-align: center;
      color: black;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/routes/RecommendationsTables/components/styles.js